export default {"src":"/_next/static/media/attract-best-salaries.2aad3730.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};